import React, { FC, ReactNode } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import V2PieChart from '@/common/components/Charts/V2PieChart';

/**
 * @Description 婚姻情况 有无车/房产
 */
const CommonPie: FC<{
  data: any[],
  title: ReactNode | string, // 支持自定义标题内容或者直接传入标题
  resizable?: boolean
  colors?: string[];
}> = ({
  data,
  title,
  resizable = false,
  colors,
}) => {
  return (
    <div className={cs(styles.chartWrapper, styles.pieChart, 'pd-16')}>
      {
        React.isValidElement(title) ? { title } : <div className='fs-14 c-222 bold'>{title}</div>
      }
      <V2PieChart
        title=''
        type='circle'
        resizable={resizable}
        seriesData={[{
          data: data,
          unit: '%',
          animation: false,
          radius: ['46%', '58%'],
          center: ['28%', '52%']
        }]}
        colors={colors}
        height={260}
      />
    </div>
  );
};

export default CommonPie;

